import * as React from "react";
import { getBeaOffers } from "../api";

import {
  BeaOffer,
  CommissionData,
} from "../types";

export interface CampaignContext {
  beaOffers: BeaOffer[];
  exampleText: string;
  commissions: {
    [accountType: string]: CommissionData;
  };
  getBeaOffers: () => Promise<void>;
}

const defaultValue: CampaignContext = {
  beaOffers: [],
  exampleText: "aaa",
  commissions: {},
  getBeaOffers: () => Promise.reject(),
}

const { Provider, Consumer } = React.createContext(defaultValue);

export { Consumer };

interface OwnProps {
  children: React.ReactNode;
}

type Props = OwnProps;

interface State {
  beaOffers: BeaOffer[];
  exampleText: string;
  commissions: {
    [accountType: string]: CommissionData;
  };
};

const defaultState: State = {
  beaOffers: [],
  exampleText: "aaa",
  commissions: {},
};

export default class CampaignContextProvider extends React.PureComponent<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);

    this.state = defaultState;
  }

  render() {
    const { children } = this.props;
    const {
      exampleText,
      beaOffers,
      commissions,
    } = this.state;
    return (
      <Provider
        value={{
          beaOffers: beaOffers,
          exampleText: exampleText,
          commissions: commissions,
          getBeaOffers: this.getBeaOffers,
        }}
      >
        {children}
      </Provider>
    );
  }

  getBeaOffers = async () => {
    const { beaOffers } = await getBeaOffers();
    this.setState({
      beaOffers: beaOffers,
    });
  };
}



// WEBPACK FOOTER //
// ./src/context/CampaignContext.tsx